import { render, staticRenderFns } from "./DialogCandidateContact.vue?vue&type=template&id=335e5108&scoped=true"
import script from "./DialogCandidateContact.js?vue&type=script&lang=js&external"
export * from "./DialogCandidateContact.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e5108",
  null
  
)

export default component.exports